module.exports = __webpack_public_path__ + "befcc2e76327ba68a94754e34f3a7bee.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/umbrella-red.png
// module id = 2955
// module chunks = 0